import { useEffect, useRef } from "react";

function resolveMaxHeight(maxHeight) {
  if (typeof maxHeight === "number") return maxHeight;
  if (typeof maxHeight !== "string") return null;
  if (maxHeight.endsWith("vh") && typeof window !== "undefined") {
    const vh = Number.parseFloat(maxHeight);
    return Number.isFinite(vh) ? Math.floor(window.innerHeight * (vh / 100)) : null;
  }
  const px = Number.parseInt(maxHeight, 10);
  return Number.isFinite(px) ? px : null;
}

export function useAutoGrowTextarea(value, { maxHeight = "40vh" } = {}) {
  const ref = useRef(null);

  useEffect(() => {
    const textarea = ref.current;
    if (!textarea) return;

    const maxHeightPx = resolveMaxHeight(maxHeight);
    textarea.style.height = "auto";
    textarea.style.maxHeight = typeof maxHeight === "number" ? `${maxHeight}px` : maxHeight;

    const nextHeight = maxHeightPx
      ? Math.min(textarea.scrollHeight, maxHeightPx)
      : textarea.scrollHeight;
    textarea.style.height = `${nextHeight}px`;
    textarea.style.overflowY = textarea.scrollHeight > nextHeight ? "auto" : "hidden";
  }, [value, maxHeight]);

  return ref;
}
